export const NUI = 'NuiPreviewer';
export const PAYLOAD = 'PayloadPreviewer';
export const STATIC_CONTENT = 'StaticContentPreviewer';
